import api from '@/services/api/api';

export const useTests = (
  params = {
    page: 1,
    filters: {},
  },
) => {
  const tests = useInfiniteQuery(
    ['tests', params.filters, params.page],
    async ({ pageParam = toValue(params.page) }) => {
      const { data } = await api.tests.getTests(
        {
          per_page: params.per_page,
          page: pageParam,
        },
        toValue(params.filters),
      );
      return data;
    },
    {
      staleTime: Infinity,
      select: ({ pages }) => ({
        meta: pages[pages.length - 1].meta,
        data: pages.flatMap((data) => data.data),
      }),
      getNextPageParam: (data) => {
        return data.meta.current_page < data.meta.last_page
          ? data.meta.current_page + 1
          : undefined;
      },
      refetchOnMount: true,
      keepPreviousData: true,
    },
  );

  const queryClient = useQueryClient();

  const resetPage = (filters) => {
    queryClient.setQueryData(['tests', filters], (prevData) => {
      if (!prevData) return;
      return {
        pages: [prevData.pages[0]],
        pageParams: [prevData.pageParams[0]],
      };
    });
  };

  onServerPrefetch(async () => {
    await tests.suspense();
  });

  return {
    tests,
    resetPage,
  };
};
